/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppAiAgentConfigApprovePathParams,
	WhatsAppAiAgentConfigApproveResponse,
} from '../types/WhatsAppAiAgentConfigApprove'

/**
 * POST /campaigns/:campaignId/whatsapp-ai-config/approve
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiAgentConfigController.php WhatsAppAiAgentConfigController::approve
 */
export async function whatsAppAiAgentConfigApprove(
	campaignId: WhatsAppAiAgentConfigApprovePathParams['campaignId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppAiAgentConfigApproveResponse>> {
	return axiosInstance.post(`/campaigns/${campaignId}/whatsapp-ai-config/approve`, undefined, config)
}
